/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';


export const GameTitel: React.FunctionComponent<{ name?: string;}> = (args) => {
  return (<div css={css`text-align: center; color: black; color: white`}>{args.name}</div>);
}